// import { useState } from "react";
// import "./profile.scss";
// import Sidebar from "../../components/sidebar/Sidebar";
// import Navbar from "../../components/navbar/Navbar";

// const Profile = () => {
//   let [token] = useState(localStorage.getItem("token"));
//   let [data] = useState(JSON.parse(localStorage.getItem("admindata")));
//   console.log(data);

//   const redirectToLogin = () => {
//     alert("Please login first, then you can access this page...");
//     window.location.href = "/";
//   };

//   // Function to display all roles separated by commas
//   const displayRoles = () => {
//     if (!data.role_names || data.role_names.length === 0) {
//       return "No roles assigned";
//     }
//     return data.role_names.join(", ");
//   };

//   return (
//     <>
//       {!token && redirectToLogin()}
//       {token && (
//         <div className="profile">
//           <Sidebar />
//           <div className="profileContainer">
//             <Navbar />
//             <div className="top">
//               <div className="left">
//                 <h1 className="title">User Information</h1>
//                 <div className="item">
//                   <div className="details">
//                     <h1 className="itemTitle">{data.name}</h1>
//                     <div className="detailItem">
//                       <span className="itemKey">Email:</span>
//                       <span className="itemValue">{data.email}</span>
//                     </div>
//                     <div className="detailItem">
//                       <span className="itemKey">Phone Number:</span>
//                       <span className="itemValue">{data.phone_no}</span>
//                     </div>
//                     <div className="detailItem">
//                       <span className="itemKey">Role:</span>
//                       <span className="itemValue">{displayRoles()}</span>
//                     </div>
//                     <div className="detailItem">
//                       <span className="itemKey">Center Name:</span>
//                       <span className="itemValue">{data.center_name}</span>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default Profile;
import React, { useState } from "react";
import "./profile.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import {
  Card,
  CardContent,
  Typography,
  Avatar,
  Divider,
  Chip,
  Box,
} from "@mui/material";
import {
  Email as EmailIcon,
  Phone as PhoneIcon,
  Badge as BadgeIcon,
  LocationCity as LocationIcon,
} from "@mui/icons-material";
import { createTheme, ThemeProvider } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#7451f8",
    },
    secondary: {
      main: "#6c757d",
    },
  },
});

const Profile = () => {
  let [token] = useState(localStorage.getItem("token"));
  let [data] = useState(JSON.parse(localStorage.getItem("admindata")));

  const redirectToLogin = () => {
    alert("Please login first, then you can access this page...");
    window.location.href = "/";
  };

  const displayRoles = () => {
    if (!data.role_names || data.role_names.length === 0) {
      return "No roles assigned";
    }
    return data.role_names.join(", ");
  };

  if (!token) {
    redirectToLogin();
    return null;
  }

  return (
    <ThemeProvider theme={theme}>
      <div className="profile">
        <Sidebar />
        <div className="profileContainer">
          <Navbar />
          <div className="contentWrapper">
            <Card className="profileCard">
              <CardContent className="cardContent">
                <Typography variant="h5" className="profileTitle">
                  User Profile
                </Typography>

                <Box className="profileContent">
                  <Box className="avatarSection">
                    <Avatar
                      sx={{
                        width: 120,
                        height: 120,
                        bgcolor: theme.palette.primary.main,
                        fontSize: "2.5rem",
                        mb: 2,
                      }}
                    >
                      {data.name.charAt(0).toUpperCase()}
                    </Avatar>
                    <Typography variant="h6" className="userName">
                      {data.name}
                    </Typography>
                    <Chip
                      label={data.center_name}
                      color="primary"
                      size="small"
                      sx={{ mt: 1 }}
                    />
                  </Box>

                  <Divider orientation="vertical" flexItem sx={{ mx: 4 }} />

                  <Box className="detailsSection">
                    <DetailItem
                      icon={<EmailIcon />}
                      label="Email"
                      value={data.email}
                    />
                    <DetailItem
                      icon={<PhoneIcon />}
                      label="Phone Number"
                      value={data.phone_no}
                    />
                    <DetailItem
                      icon={<BadgeIcon />}
                      label="Roles"
                      value={displayRoles()}
                    />
                    <DetailItem
                      icon={<LocationIcon />}
                      label="Center"
                      value={data.center_name}
                    />
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
};

const DetailItem = ({ icon, label, value }) => (
  <Box className="detailItem">
    <Box className="detailIcon">
      {React.cloneElement(icon, {
        fontSize: "small",
        sx: { color: "#7451f8" },
      })}
    </Box>
    <Box className="detailContent">
      <Typography variant="subtitle2" className="detailLabel">
        {label}
      </Typography>
      <Typography variant="body1" className="detailValue">
        {value || "-"}
      </Typography>
    </Box>
  </Box>
);

export default Profile;
